export function getA11yStatusMessage({ isOpen, selectedItem, highlightedItem, resultCount, previousResultCount, itemToString }) {
  if (!isOpen) {
    return selectedItem ? itemToString(selectedItem) : '';
  }
  if (!resultCount) {
    return 'No results are available.';
  }

  if (resultCount !== previousResultCount) {
    return `${resultCount} result${
      resultCount === 1 ? ' is' : 's are'
    } available, use up and down arrow keys to navigate. Press Enter key to select.`;
  }

  if (highlightedItem) {
    return itemToString(highlightedItem);
  }

  return '';
}
